import { ChakraBox, ChakraFlex, ChakraText } from '@equip.health/ui';

// Bouncing dots, with an opacity-pulse fallback under reduced motion.
const TYPING_ANIMATION_KEYFRAMES = `
  @keyframes mai-chat-typing-bounce {
    0%, 80%, 100% { transform: scale(0.6); opacity: 0.4; }
    40% { transform: scale(1); opacity: 1; }
  }
  @keyframes mai-chat-typing-fade {
    0%, 100% { opacity: 0.35; }
    50% { opacity: 1; }
  }
  @media (prefers-reduced-motion: no-preference) {
    .mai-chat-typing-bounce-dot {
      animation: mai-chat-typing-bounce 1.4s infinite ease-in-out both;
    }
  }
  @media (prefers-reduced-motion: reduce) {
    .mai-chat-typing-bounce-dot {
      animation: mai-chat-typing-fade 2s infinite ease-in-out both;
    }
  }
`;

const Dot = ({ delay }: { delay: string }) => (
  <ChakraBox
    className="mai-chat-typing-bounce-dot"
    width="3px"
    height="3px"
    borderRadius="50%"
    background="neutral.tertiary"
    sx={{ animationDelay: delay }}
  />
);

const TypingDots = () => (
  <ChakraFlex alignItems="flex-end" gap="2px" paddingBottom="3px">
    <style>{TYPING_ANIMATION_KEYFRAMES}</style>
    <Dot delay="-0.32s" />
    <Dot delay="-0.16s" />
    <Dot delay="0s" />
  </ChakraFlex>
);

const MaiChatThinking = () => (
  <ChakraFlex
    data-testid="mai-chat-thinking"
    alignItems="flex-end"
    gap="2px"
    padding="4px 0"
    role="status"
    aria-label="Maud AI is thinking"
  >
    <ChakraText color="neutral.secondary" fontSize="14px" lineHeight="1">
      Thinking
    </ChakraText>
    <TypingDots />
  </ChakraFlex>
);

export default MaiChatThinking;
